import { lazy } from 'react';

import { withSuspense } from '@/shared/lib/hocs/with-suspense.hoc';
import { PageLoader } from '@/widgets/page';

export const VirtualCockpitPage = withSuspense(
	lazy(async () => await import('./virtual-cockpit-page.component')),
	PageLoader,
);
